import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Globals } from '../../../app.globals';
import { PlayerService } from '../../services/player.service';

@Component({
  selector: 'app-song-info-avatar-next-song',
  templateUrl: './song-info-avatar-next-song.component.html',
  styleUrls: ['./song-info-avatar-next-song.component.css']
})
export class SongInfoAvatarNextSongComponent implements OnInit {
  @Input() nextToCurrentSong: any;
  private image: any;
  private playerEventSubscriber = null;

  constructor(private playerService: PlayerService) { }

  ngOnInit() {
    this.setImage();
    this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
      if (event.type === 'track:id') {
        if(this.playerService.currentTrackData2()){
        this.nextToCurrentSong = this.playerService.currentTrackData2().metaData;
        this.setImage();
        }
      }
    });
  }

  setImage() {
    let itemType = (typeof this.nextToCurrentSong !== 'undefined' && typeof this.nextToCurrentSong._type !== 'undefined') ? this.nextToCurrentSong._type : 'playlist';
    switch (itemType) {
      case 'album':
        if (this.nextToCurrentSong.image.indexOf('mspro-photos') <= 0) {
          this.image = new Globals().domain;
          this.image += (this.nextToCurrentSong && this.nextToCurrentSong.image !== '' && this.nextToCurrentSong.image != null) ?
            this.nextToCurrentSong.image : '/images/artist_default_avatar.jpg';
        } else {
          this.image = this.nextToCurrentSong.image;
        }
        break;
      case 'playlist':
        this.image = new Globals().apiEndpoint + 'playlists/get-avatar?playlist_id=' + this.nextToCurrentSong.id;
        break;
      case 'song':
        this.image = (this.nextToCurrentSong.album != null && this.nextToCurrentSong.album.image != null && this.nextToCurrentSong.album.image.trim() !== '')
          ? this.nextToCurrentSong.album.image : (this.nextToCurrentSong.artist != null && this.nextToCurrentSong.artist.image != null &&
            this.nextToCurrentSong.artist.image.trim() !== '' && this.nextToCurrentSong.artist.image != null ?
            this.nextToCurrentSong.artist.image : new Globals().domain + '/images/artist_default_avatar.jpg');
        break;
      case 'artist':
        this.image = (this.nextToCurrentSong.image && this.nextToCurrentSong.image !== '') ? this.nextToCurrentSong.image :
          new Globals().domain + '/images/artist_default_avatar.jpg';
        break;
      case 'account':
        this.image = new Globals().apiEndpoint + 'api/user-avatar?id=' + this.nextToCurrentSong.screenname;
        break;
    }
  }


  ngOnDestroy() {
    if (this.playerEventSubscriber != null) {
      this.playerEventSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/player/song-info/song-info-avatar-next-song/song-info-avatar-next-song.component.ts